import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { EditableFulfillmentPlanDate } from '../fulfillment-plan-dates/editable-fulfillment-plan-date';
import { ReadonlyFulfillmentPlanDate } from '../fulfillment-plan-dates/readonly-fulfillment-plan-date';
import { ShipmentDetailsField } from '../field';
import messages from '../messages';
import { updateFulfillmentPlansHoldUntil } from '../../../../../../fulfillment-plans/fulfillment-plans.api';
import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlanProperty } from '../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useHasFulfillmentPlanRestriction } from '../../../restrictions-context';
import { UiRestrictions } from '../../../../../../enums/component-states';
import { useIsFulfillmentPlanEditable } from '../use-shipment-details';
import { ON_HOLD } from '../../../../../../services/api/order-status-from-view-service';
import Global from '../../../../../../store/global-selectors';
import { DateService } from '../../../../../../services/date-service';

const HoldUntilDateFieldId = 'hold-until-date';

export const HoldUntilDate = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const { holdUntilDate } = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'fulfillmentPlanDates');
  const isHoldUntilEditable = useIsFulfillmentPlanEditable(fulfillmentPlanId);
  const orderGridStatus = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanOrderGridStatus(state, {
      fulfillmentPlanId,
    }),
  );

  const isEmptyDate = DateService.isEmptyDate(holdUntilDate);
  const isMaxDate = DateService.isMaxDate(holdUntilDate);
  const isOnHoldIndefinitely = orderGridStatus === ON_HOLD && (isEmptyDate || isMaxDate);
  const isRestricted = useHasFulfillmentPlanRestriction(UiRestrictions.HoldUntilDate);

  const renderContent = () => {
    if (isHoldUntilEditable) {
      return (
        <EditableFulfillmentPlanDate
          apiCall={updateFulfillmentPlansHoldUntil}
          dateValueUtc={holdUntilDate}
          disabled={isRestricted}
          emptyStateMessageDescriptor={isOnHoldIndefinitely ? messages.holdIndefinitely : undefined}
          fulfillmentPlanId={fulfillmentPlanId}
          id={HoldUntilDateFieldId}
        />
      );
    }

    if (isOnHoldIndefinitely) {
      return <FormattedMessage {...messages.holdIndefinitely} />;
    }

    return <ReadonlyFulfillmentPlanDate dateValueUtc={holdUntilDate} />;
  };

  return (
    <ShipmentDetailsField label={<FormattedMessage {...messages.holdUntilDate} />} labelFor={HoldUntilDateFieldId}>
      {renderContent()}
    </ShipmentDetailsField>
  );
};
